@import (reference) '../../../constants/spacing.module.less';

.unit-adornment {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 @space-8;
  font-size: 12px;
  line-height: 20px;
  color: var(--default--icon--fill-color--12);
}
